import gql from 'graphql-tag';

export default gql`
  mutation DeleteInvite($inviteId: ID!) {
    deleteInvite(id: $inviteId) {
      id
    }
  }
`;
